import { useLocation } from "react-router-dom";

/**
 * Extracts the client name from backoffice URLs.
 * URL pattern: /backoffice-{section}-{clientName}-web
 * Example: /backoffice-login-American-web -> "American"
 */
const useClientName = () => {
  const location = useLocation();
  const path = location.pathname;

  // Match pattern: /backoffice-{something}-{clientName}-web
  const match = path.match(/^\/backoffice-(?:login|users|user_details)-(.+)-web$/);
  return match ? match[1] : "corporativo";
};

export default useClientName;
